import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { DRAFT_STALE_TIME_MS } from "../constants";
import { isSegmentCountable, toVacancyFilterBody } from "../mappers";

import { segmentsQueryKeys } from "@/features/segments/api/queryKeys";
import type { SegmentVacanciesResponse } from "@/features/segments/types";
import { instance } from "@/lib/axios/instance";

type UseSegmentVacancyTotalParams = Parameters<
  typeof segmentsQueryKeys.vacancyTotal
>[0] & { enabled: boolean };

export function useSegmentVacancyTotal({
  enabled,
  ...params
}: UseSegmentVacancyTotalParams) {
  const query = useQuery<number, AxiosError>({
    queryKey: segmentsQueryKeys.vacancyTotal(params),
    queryFn: ({ signal }) =>
      instance
        .post<SegmentVacanciesResponse>(
          "/api/v2/Segments/drafts/vacancies",
          {
            ...params.body,
            ...toVacancyFilterBody(params.filters),
            parts: "Page",
            list: params.list,
            search: params.search,
            pageSize: 1,
          },
          { signal },
        )
        .then((res) => res.data.totalCount),
    enabled: enabled && isSegmentCountable(params.body),
    staleTime: DRAFT_STALE_TIME_MS,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

  return { count: query.data ?? 0, isLoading: query.isLoading };
}
